import React, { useCallback, useContext, useEffect, useMemo } from 'react'
import { selectPlaygroundEditMode } from '../playgroundSlice'
import { ActionNames } from '../context/view/types'
import ViewContext from '../context/view/Context'
import { useReduxSelector } from 'store'
import PlaceFrame from './PlaceFrame'

const Place: React.FC = () => {
  const { layers: { borderPoints }, dispatch } = useContext(ViewContext)
  const isEditMode = useReduxSelector(selectPlaygroundEditMode)

  const updateBorderPoints = useCallback((v: boolean) => {
    if (isEditMode || !v) dispatch({ type: ActionNames.updateLayer, payload: { borderPoints: v } })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode])

  useEffect(() => {
    if (borderPoints) {
      const handleDbClick = () => updateBorderPoints(false)
      window.addEventListener('dblclick', handleDbClick)
      return () => window.removeEventListener('dblclick', handleDbClick)
    }
  }, [borderPoints, updateBorderPoints])

  useEffect(() => {
    if (borderPoints && !isEditMode) updateBorderPoints(false)
  }, [borderPoints, isEditMode, updateBorderPoints])

  return (
    <div className='playground__place'>
      {useMemo(() => <PlaceFrame
        borderPoints={borderPoints}
        showBorderPoints={() => updateBorderPoints(true)}
      />, [borderPoints, updateBorderPoints])}
    </div>
  )
}

export default Place